import { createContext } from "react";

interface PhysicalExamErrorsContextOptions {
  physicalExamErrors: string[];
  addPhysicalExamError: (error: string) => void;
  removePhysicalExamError: (error: string) => void;
}

export const PhysicalExamErrorsContext = createContext<PhysicalExamErrorsContextOptions>({
  physicalExamErrors: [],
  addPhysicalExamError: () => null,
  removePhysicalExamError: () => null,
});
